import { PersonAddress } from "../Request";
import { SchoolYear } from "../SchoolYear/SchoolYear";
import { GenderEnum } from "../Shared";
import { SchoolCandidateRemarkType } from "./RemarkTypes";
import { SchoolCandidateStatus } from "./SchoolCandidateStatus";

export interface SchoolCandidate {
  id: number;
  schoolYearId: number;
  oib?: string;
  firstName: string;
  lastName: string;
  dateOfBirth: Date | string;
  genderId: GenderEnum;
  motherName?: string;
  fatherName?: string;
  residence?: PersonAddress;
  permanentAddressNote?: string | null;
  schoolCandidateAddReasonId: number | null;
  schoolCandidateAddReasonOther: string | null;
  schoolCandidateCancelReasonId: number | null;
  schoolCandidateCancelReasonOther: string | null;
  institutionId?: number;
  statusId: SchoolCandidateStatus;
  alternativeCode: string | null;
  schoolCandidateAlternativeCodeReasonId: number | null;
  schoolCandidateAlternativeCodeTypeId: number | null;
  uoguCountyId: number;

  // These are used in details
  schoolYear?: SchoolYear;
  isOibConnected: boolean;
  uoguNote?: string | null;
  isHandicapped: boolean;
  isNew?: boolean;
  oibStatus: number; // This is baby status, used for a console application. Unused in the app
  religiousOrMinorityInstitutionName: string | null;
  hasRequest: boolean;
  hasRequestDraft: boolean;
}

export const getDefaultSchoolCandidate = (): SchoolCandidate => {
  return {
    id: 0,
    schoolYearId: 0,
    firstName: "",
    lastName: "",
    dateOfBirth: new Date(),
    genderId: GenderEnum.Male, // Does not allow null or Unknown
    statusId: SchoolCandidateStatus.notSent,
    uoguCountyId: 0,

    isOibConnected: false,
    isHandicapped: false,
    schoolCandidateAddReasonId: null,
    schoolCandidateAddReasonOther: null,
    schoolCandidateCancelReasonId: null,
    schoolCandidateCancelReasonOther: null,
    alternativeCode: null,
    schoolCandidateAlternativeCodeReasonId: null,
    schoolCandidateAlternativeCodeTypeId: null,
    oibStatus: 0,
    religiousOrMinorityInstitutionName: null,
    hasRequest: false,
    hasRequestDraft: false,
  };
};

export interface SchoolCandidateRemark {
  id: number;
  schoolCandidateId: number;
  remark: string;
  schoolCandidateRemarkTypeId: SchoolCandidateRemarkType;
  dateCreated: string;
  dateUpdated: string | null;
}
